import JSEncrypt from 'jsencrypt'

// 公钥key
const publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCMlygMRGrnGL//9rEp6xvqRlWGt5PEuB3/Z3Njyrlhm3PBwvDj4c0BTPy2KpjHPD9DYA8La9J/ph+sxPTPwYzNGYzVRY1fAvpztVGKOeKsIj9lNA9OfjCnl0oaQH6TxuaUMXba9pgScccPZY0q7Hm8+zBaLXLoTuw+0AJq5Nc7IQIDAQAB'

export default {
  /* JSEncrypt加密 */
  rsaPublicData(data) {
    var jsencrypt = new JSEncrypt()
    jsencrypt.setPublicKey(publicKey)
    // 如果是对象/数组的话，需要先JSON.stringify转换成字符串
    if(data instanceof Object) data = JSON.stringify(data)
    // console.log(data)
    var result = jsencrypt.encrypt(data)
    return result
  },
  /* JSEncrypt解密 */
  rsaPrivateData(data) {
    var jsencrypt = new JSEncrypt()
    jsencrypt.setPrivateKey(privateKey)
    // 如果是对象/数组的话，需要先JSON.stringify转换成字符串
    var result = jsencrypt.encrypt(data)
    return result
  }
}
